import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./App.css";

import bg from "../src/assets/stockImg.png";
import bg1 from "../src/assets/stockImgText.png";
import bgv from "./assets/StockTradingvd.webm";

/* ✅ USE YOUR LATEST VERSION 2 URL HERE */
const GOOGLE_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycby3R732Sc_3HyQ0zYxVP8WuHntIQT205qR_8Bbk4uCYsUpjLvPEfJOtyLDJIt83S4YWvg/exec";

function App() {
  const [stockInput, setStockInput] = useState("");
  const [location, setLocation] = useState("");
  const [locationStatus, setLocationStatus] = useState("detecting"); // detecting | done | denied | unavailable
  const [showReportModal, setShowReportModal] = useState(false);

  /* =========================
     AUTO DETECT LOCATION (on load)
  ========================= */
  useEffect(() => {
    console.log("location:", location, "| status:", locationStatus);
  }, [location, locationStatus]);

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocationStatus("unavailable");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
            { headers: { "Accept-Language": "en", "User-Agent": "StockAnalysisApp/1.0" } }
          );
          const data = await res.json();
          const addr = data.address || {};
          const country = addr.country || "";
          const city =
            addr.city ||
            addr.town ||
            addr.village ||
            addr.municipality ||
            addr.state_district ||
            addr.state ||
            addr.county ||
            addr.suburb ||
            "";
          let place = [city, country].filter(Boolean).join(", ");
          if (!place && data.display_name) {
            const parts = data.display_name.split(", ").map((p) => p.trim()).filter(Boolean);
            if (parts.length >= 2) place = `${parts[0]}, ${parts[parts.length - 1]}`;
          }
          if (!place) place = `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
          setLocation(place);
        } catch {
          setLocation(`${latitude.toFixed(4)}, ${longitude.toFixed(4)}`);
        }
        setLocationStatus("done");
      },
      () => setLocationStatus("denied"),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
    );
  }, []);

  /* =========================
     ANALYZE BUTTON
  ========================= */
  const handleAnalysis = () => {
    if (!stockInput.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Input Required",
        text: "Enter stock name or code",
      });
      return;
    }

    setShowReportModal(true);
  };

  /* =========================
     SAVE TO GOOGLE SHEET (POST via form – avoids CORS)
     Script receives e.parameter.phone and e.parameter.stock in doPost(e)
  ========================= */
  const saveToSheet = (phone) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = GOOGLE_SCRIPT_URL;
    form.target = "google-script-frame";
    form.style.display = "none";

    const phoneInput = document.createElement("input");
    phoneInput.name = "phone";
    phoneInput.value = phone;
    form.appendChild(phoneInput);

    const stockInputField = document.createElement("input");
    stockInputField.name = "stock";
    stockInputField.value = stockInput.trim();
    form.appendChild(stockInputField);

    const locationInput = document.createElement("input");
    locationInput.name = "location";
    locationInput.value = location.trim() || (locationStatus === "denied" ? "Not shared" : "");
    form.appendChild(locationInput);

    let iframe = document.getElementById("google-script-frame");
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.name = "google-script-frame";
      iframe.id = "google-script-frame";
      iframe.style.display = "none";
      document.body.appendChild(iframe);
    }
    document.body.appendChild(form);
    form.submit();
    form.remove();
  };

  /* =========================
     WHATSAPP FLOW
  ========================= */
  const handleReceiveViaWhatsApp = () => {
    setShowReportModal(false);

    Swal.fire({
      title: "Enter your phone number",
      input: "tel",
      inputPlaceholder: "9876543210",
      showCancelButton: true,
      confirmButtonText: "Send",
      confirmButtonColor: "#25D366",
      preConfirm: (value) => {
        if (!/^\d{10,15}$/.test(value)) {
          Swal.showValidationMessage("Enter valid WhatsApp phone number");
        }
        return value;
      },
    }).then((result) => {
      if (!result.isConfirmed) return;

      saveToSheet(result.value);

      Swal.fire({
        icon: "success",
        title: "Saved!",
        text: "We will contact you on WhatsApp soon.",
      });
    });
  };

  /* =========================
     UI
  ========================= */
  return (
    <div className="main-container">
      <div className="overlay">
        <video autoPlay loop muted playsInline className="overlay-video">
          <source src={bgv} type="video/mp4" />
        </video>

        <div className="overlay-video-dark"></div>

        <img src={bg} alt="" />
        <img src={bg1} alt="" />

        <div className="inputCls">
          <div className="input-container">
            <input
              type="text"
              className="stock-input"
              placeholder="Stock Name/Stock Code"
              value={stockInput}
              onChange={(e) => setStockInput(e.target.value)}
            />
          </div>
          {locationStatus === "detecting" && (
            <div className="input-container location-hint">Detecting location…</div>
          )}
          {locationStatus === "done" && location && (
            <div className="input-container location-hint">Location: {location}</div>
          )}
          {locationStatus === "denied" && (
            <div className="input-container location-hint">Location: Not shared</div>
          )}
          {locationStatus === "unavailable" && (
            <div className="input-container location-hint">Location: Unavailable</div>
          )}

          <div className="button-container">
            <button className="analyze-button" onClick={handleAnalysis}>
              Start analysis
            </button>
          </div>
        </div>
      </div>

      {showReportModal && (
        <div
          className="report-modal-overlay"
          onClick={() => setShowReportModal(false)}
        >
          <div
            className="report-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Stock Analysis Report is Ready</h2>

            <button
              className="report-modal-whatsapp-btn"
              onClick={handleReceiveViaWhatsApp}
            >
              Receive via WhatsApp
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;